import { render } from "./IconText.vue?vue&type=template&id=5dc4c212&scoped=true"
import script from "./IconText.vue?vue&type=script&lang=js"
export * from "./IconText.vue?vue&type=script&lang=js"

import "./IconText.vue?vue&type=style&index=0&id=5dc4c212&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc4c212"]])

export default __exports__